// Skin Guide
document.addEventListener('click', e => {
  const isSkinBtn = e.target.hasAttribute('data-skin-control');

  if (isSkinBtn) {
    let skinAgeTypes = [];
    
    if(document.querySelector('.skin-guide').dataset.ageTypes){
      skinAgeTypes = JSON.parse(document.querySelector('.skin-guide').dataset.ageTypes)?.filter(e => e.length); // filter empty strings.
    }

    const skinTypes = JSON.parse(document.querySelector('.skin-guide').dataset.skinTypes);
    const skinTypeIndex = parseInt(e.target.dataset.skinTypeIndex);
    const skinTypeEls = document.querySelectorAll(`[data-skin-type-index="${skinTypeIndex}"]`);
    const activeEls = document.querySelectorAll('.skin-guide .active');
    const skinNavPrev = document.querySelector('.skin-guide__nav-arrow-prev');
    const skinNavNext = document.querySelector('.skin-guide__nav-arrow-next');
    const skinTypeIndexPrev = skinTypeIndex === 0 ? skinTypes.length - 1 : skinTypeIndex - 1;
    const skinTypeIndexNext = skinTypeIndex === skinTypes.length - 1 ? 0 : skinTypeIndex + 1;

    activeEls.forEach(el => el.classList.remove('active'));
    skinTypeEls.forEach(el => el.classList.add('active'));
    skinNavPrev.dataset.skinTypeIndex = skinTypeIndexPrev;
    skinNavNext.dataset.skinTypeIndex = skinTypeIndexNext;
    
    skinNavPrev.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexPrev].replace(/_/g, ' ') : skinTypes[skinTypeIndexPrev].replace(/_/g, ' ');
    skinNavNext.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexNext].replace(/_/g, ' ') : skinTypes[skinTypeIndexNext].replace(/_/g, ' ');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const ritualATCAll = document.getElementById('ritual-atc-all');
  const sampleLeftArrow = document.getElementById('left-arrow');
  const sampleRightArrow = document.getElementById('right-arrow');

  if(ritualATCAll){
    ritualATCAll.addEventListener('click', e=> {
      const ritualVariants = ritualATCAll.dataset['ritualVariantId'].split(',');
          
      let formData = {
        'items': ritualVariants.map(variant => {
          return { id: parseInt(variant), quantity: 1}
        })
      };

      // Start loading bar at the top of the page
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      queryAjaxPost('/cart/add.js', JSON.stringify(formData)).then(() => refreshCart());
    });
  }

  if(sampleLeftArrow){
    sampleLeftArrow.addEventListener('click', e => {
      const leftBackground = document.getElementById('arrow-background-left');
      const rightBackground = document.getElementById('arrow-background-right');
      const sampleWindow = document.getElementById('sample-scroll');

      rightBackground.style.display = '';
      sampleWindow.scrollBy({
        left: -109,
        behavior: 'smooth'
      });
      leftBackground.style.display = 'none';

    });
  }
  if(sampleRightArrow){
    sampleRightArrow.addEventListener('click', e => {
      const leftBackground = document.getElementById('arrow-background-left');
      const rightBackground = document.getElementById('arrow-background-right');
      const sampleWindow = document.getElementById('sample-scroll');

      leftBackground.style.display = '';
      sampleWindow.scrollBy({
        left: 109,
        behavior: 'smooth'
      });
      rightBackground.style.display = 'none';

    });
  }
});

document.addEventListener('click', function (event) {
  const target = event.target;

  if (target.matches('.CartSamples button:not(.Button--disabled')) {
    const cartSamples = target.closest('.CartSamples');
    const sampleVariantIds = cartSamples ? cartSamples.dataset.sampleVariantIds : null;
    const variantToAdd = target.dataset.sampleInCart ? target.dataset.variantId : null;
    const isCheckoutSelector = document.querySelector('.CartSamples').dataset.checkoutSelector;
    const cartSampleButtons = document.querySelectorAll('.CartSamples button');

    if (isCheckoutSelector) {
      cartSampleButtons.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      })
    }

    queryAjaxGet('/cart.js').then((response) => updateCart(variantToAdd, sampleVariantIds, response, isCheckoutSelector));
  }
});



document.addEventListener('cart:change', e => {
  queryAjaxGet('/cart.js').then((response) => {
      checkSampleCartOfferings(response)
  });
});

// Run on the /cart url to remove free samples
if(window.location.href.includes('.com/cart')){
  queryAjaxGet('/cart.js').then((response) => {
    checkSampleCartOfferings(response)
  });
}

function checkSampleCartOfferings(cart){
  const samples = document.getElementById('CartSamples');
  const sampleThreshold = parseInt(samples.dataset.thresholdInCents);
  const sampleVariants = samples.dataset.sampleVariantIds.split(',');
  const cartVariants = cart.items.map(item => item.id.toString());
  const findDuplicates = (arr1,arr2) => {
      const combinedArray = arr1.concat(arr2);
      const elementCount = {};
      const duplicates = [];
      for (const element of combinedArray) {
          if (elementCount[element]) {
              duplicates.push(element);
          } else {
              elementCount[element] = 1;
          }
      }
      return duplicates;
  }
  const doesCartHaveSampleOfferings = findDuplicates(sampleVariants,cartVariants);
  let emptySamples = {};

  if(cart.total_price < sampleThreshold && doesCartHaveSampleOfferings.length){
      sampleVariants.forEach(variant => {
          // Set all variants to 0 quantity 
          emptySamples[variant] = 0;
      })

      // Update cart with empty sample variants
      queryAjaxPost('/cart/update.js', JSON.stringify({updates: emptySamples})).then(() => {
          refreshCart(false);
      });
  }
}

function buildUpdatePayload(variantId, samplesList, cart, addMultiVariants, allowDuplicates) {
  const payload = {
    updates: {}
  };

  if (addMultiVariants) {
    const cartVariantIds = cart.items.map(item => item.id.toString());
    samplesList = samplesList.split(',');
    samplesList.forEach(variantId => {
      if (!cartVariantIds.includes(variantId)) {
        payload.updates[variantId] = 1
      } else if (allowDuplicates) {
        const cartVariant = cart.items.find(item => item.id.toString() === variantId);
        payload.updates[variantId] = cartVariant.quantity + 1;
      }
    });

    return payload;
  }

  if (variantId) {
    payload.updates[variantId] = 1;
  }

  if (samplesList && cart && cart.items) {
    var giftsInCart = 0;
    var removeExisting = false;
    cart.items.forEach(function(item) {
        if (item.variant_id.toString() == variantId) {
            removeExisting = true;
            payload.updates[variantId] = 0;
        }

        if (samplesList.includes(item.variant_id.toString())) {
            giftsInCart = giftsInCart + 1;
        }
    });

    if (giftsInCart > 1) {
        cart.items.forEach(function(item) {
            if (samplesList.includes(item.variant_id.toString())) {
                payload.updates[item.variant_id] = 0;
            }
        });
    }
  }
  return payload;
}

function queryAjaxGet(endpoint) {
  return fetch(endpoint, {
      method: 'GET'
  }).then(function (response) {
      if (response.status === 200) {
          return response.json();
      }
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function queryAjaxPost(endpoint, payload) {
  return fetch(endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: payload
  }).then(function (response) {
      if (response.status === 200) {
          return response.json();
      }
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function refreshCart() {
  const cartButton = document.querySelector('a[aria-controls="cart-drawer"]');
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  }));

  // Finish loading bar at the top of the page
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  if(cartButton){
    if(!cartButton.ariaExpanded){
      cartButton.click();
    }
  } else {
    // Will reload only on /cart url
    window.location.reload();
  }
}

function updateCart(variantToAdd, sampleVariantIds, response, isCheckout, addMultiVariants = false, allowDuplicates = false) {
  const payload = buildUpdatePayload(variantToAdd, sampleVariantIds, response, addMultiVariants, allowDuplicates);
  queryAjaxPost('/cart/update.js', JSON.stringify(payload)).then(() => {
      if (isCheckout) {
          window.location.href = window.location.href;
      } else {
          refreshCart();
      }
  });
}


// Auto-GWP

// Add auto sample item.
document.addEventListener('cart:change', e => {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', false); // Set the third parameter to false for synchronous request
  xhr.send();

  if (xhr.status === 200) {
    const response = JSON.parse(xhr.responseText);
    const productInfo = document.querySelector('[data-product-data]');

    if(productInfo){
      const productInfoData = JSON.parse(productInfo.dataset.productData);
      const isProductPresentInCart = response.items.some(obj => obj.product_id === productInfoData.id);

      if(isProductPresentInCart){
        const autoSampleProd = document.querySelector('[data-enable-auto-samples]');
        if (autoSampleProd.dataset) {
          const autoSampleIds = autoSampleProd.dataset.autoSampleIds;
          queryAjaxGet('/cart.js').then((response) => updateCart(null, autoSampleIds, response, false, true));
        }
      }
    }
  }
});

document.addEventListener('cart:change', e => {
  const cartItemList = document.querySelector('#cart-drawer');
  const autoSamplesCollection = cartItemList.dataset.autoSamplesCollection;
  const triggerAutoSamplesCollection = cartItemList.dataset.triggerAutoSamplesCollection;
  const enableVariantMetafields = cartItemList.dataset.enableVariantMetafields;

  // Use a synchronous XMLHttpRequest instead of fetch
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', false); // Set the third parameter to false for synchronous request
  xhr.send();

  if (xhr.status === 200) {
    var response = JSON.parse(xhr.responseText);

    let freeGifts = response.items.filter(item => item.price === 0);
    let regularItems = response.items.filter(item => item.price !== 0);
    let regularItemIds = regularItems.map(item => item.id);
    let itemsToRemoveCart = [];

    freeGifts.forEach(freeGift => {
      const parsedAutoSamplesCollection = JSON.parse(autoSamplesCollection);
      const parsedTriggerAutoSamplesCollection = JSON.parse(triggerAutoSamplesCollection);
      const parsedEnableVariantMetafields = JSON.parse(`{${enableVariantMetafields}}`);
      let filteredSimpleAutoSample = [];
      let filteredVariantAutoSample = [];
      let enableSampleIndexed = 'enable-sample-';
      let enableVariantSampleIndexed = 'enable-variant-sample-';

      var freeGiftObjXhr = new XMLHttpRequest();
      freeGiftObjXhr.open('GET', `/products/${freeGift.handle}.js`, false); 
      freeGiftObjXhr.send();


      if (freeGiftObjXhr.status === 200) {
        var freeGiftObj = JSON.parse(freeGiftObjXhr.responseText);
        let freeGiftContainsAutoSample = freeGiftObj.tags.filter(tag => tag.includes('auto-sample-'));
        let freeGiftContainsAutoVariantSample = freeGiftObj.tags.filter(tag => tag.includes('auto-variant-sample-'));

        if (parsedAutoSamplesCollection.length) {
          filteredSimpleAutoSample = parsedAutoSamplesCollection.filter(autoSampleProduct => autoSampleProduct.tags.some(element => element.startsWith('auto-sample-')));
          filteredVariantAutoSample = parsedAutoSamplesCollection.filter(autoSampleProduct => autoSampleProduct.tags.some(element => element.startsWith('auto-variant-sample-')));
        }

        // Check if gift has an auto-sample-{number} tag
        if (freeGiftContainsAutoSample.length && filteredSimpleAutoSample.length) {
          let autoSampleTag = freeGiftObj.tags.filter(tag => tag.startsWith('auto-sample-'));
          let autoSampleTagIndex = autoSampleTag.length ? autoSampleTag[0].match(/\d+/)[0] : '';

          // Add a number to the tag
          if (autoSampleTagIndex !== '') {
              enableSampleIndexed += autoSampleTagIndex;
          }

          if (parsedTriggerAutoSamplesCollection.length) {
              let findTriggerProduct = parsedTriggerAutoSamplesCollection.filter(triggerSample => triggerSample.tags.includes(enableSampleIndexed));
              if(findTriggerProduct.length){
                  if(!regularItemIds.includes(findTriggerProduct[0].variants[0].id)){
                      // Trigger Product found in Collection, but not found in cart - Remmove Product
                      itemsToRemoveCart.push(freeGift);
                  }
              } else {
                  // Can't find Trigger Product - Remove Product
                  itemsToRemoveCart.push(freeGift);
              }
          } else {
              // Trigger Product Collections empty - Remove Product
              itemsToRemoveCart.push(freeGift);
          }
        }

        if (freeGiftContainsAutoVariantSample.length && filteredVariantAutoSample.length) {
          let autoSampleVariantTag = freeGiftObj.tags.filter(tag => tag.startsWith('auto-variant-sample-'));
          let autoSampleVariantTagIndexes = autoSampleVariantTag.length ? autoSampleVariantTag[0].match(/\d+/g) : [];

          if (autoSampleVariantTagIndexes.length) {
              enableVariantSampleIndexed += autoSampleVariantTagIndexes[0];
          }
          
          if (parsedTriggerAutoSamplesCollection.length) {
              let findTriggerProduct = parsedTriggerAutoSamplesCollection.filter(triggerSample => triggerSample.tags.includes(enableVariantSampleIndexed));

              if(findTriggerProduct.length){
                  if(!regularItemIds.includes(findTriggerProduct[0].variants[0].id)){
                      parsedTriggerAutoSamplesCollection.forEach(triggerAutoSample => {
                          if (triggerAutoSample.tags.includes(enableVariantSampleIndexed)) {
                              let isTriggerProductPresent = false;
                              triggerAutoSample.variants.forEach(triggerVariant => {
                                  if (parsedEnableVariantMetafields[triggerAutoSample.id][triggerVariant.id].sample_variant_index == autoSampleVariantTagIndexes[1] && regularItemIds.includes(triggerVariant.id)) {
                                      isTriggerProductPresent = true;
                                  }
                              });
                              if (!isTriggerProductPresent) {
                                  // Trigger Product found in Collection, but not found in cart - Remmove Product
                                  itemsToRemoveCart.push(freeGift);
                              }
                          }
                      });
                  }
              } else {
                  // Can't find Trigger Product - Remove Product
                  itemsToRemoveCart.push(freeGift);
              }

          } else {
              // Trigger Product Collections empty - Remove Product
              itemsToRemoveCart.push(freeGift);
          }
        }
      }
    });

    if (itemsToRemoveCart.length) {
      updateTieredGifts([], itemsToRemoveCart);
    }
  }
});


function updateTieredGifts(giftsToAdd, giftsToRemove) {
  const payload = {
      updates: {}
  };

  giftsToAdd.forEach(gift => {
      payload.updates[gift] = 1;
  });

  if (giftsToRemove.length) {
      giftsToRemove.forEach(gift => {
          payload.updates[gift.variant_id] = 0;
      });
  }
  queryAjaxPost('/cart/update.js', JSON.stringify(payload)).then(() => refreshCart());
}

document.addEventListener('variant:changed', function(event) {
  const variantContainer = document.querySelector('.ProductForm__Variants');
  const isEnabledVariantAutoSamples = variantContainer.dataset.enableVariantAutoSamples;
  const variantMetafields = variantContainer.dataset.variantMetafields;
  const selectedVariant = event.detail.variant;
  const currentSampleProductIds = variantContainer.dataset.autoSampleIds.split(',');
  const convertedVariantMetafields =  JSON.parse(`{${variantMetafields}}`);    
  const allSampleProductIds = [];
      
  for(const key in convertedVariantMetafields){
      if(convertedVariantMetafields[key].sample_product_id !== null){
          allSampleProductIds.push(convertedVariantMetafields[key].sample_product_id.toString())
      }
  }

  const newSampleIdList = currentSampleProductIds.filter(id => id !== '' && !allSampleProductIds.includes(id.toString()));

  if(isEnabledVariantAutoSamples === 'true'){
      // Add Products
      if(convertedVariantMetafields.hasOwnProperty(selectedVariant.id)){
          let sampleProductId = convertedVariantMetafields[selectedVariant.id].sample_product_id;
          if(sampleProductId !== null){
              newSampleIdList.push(sampleProductId)
          }
      } 
  }
  variantContainer.dataset.autoSampleIds = newSampleIdList.join(',');
});



document.addEventListener('DOMContentLoaded', function() {
  const interval = setInterval(() => {
    const shopPayEl = document.querySelector('shopify-payment-terms');

    if (shopPayEl && shopPayEl.shadowRoot) {
      const shadow = shopPayEl.shadowRoot;

      // Example: Target the first <p> inside Shadow DOM (usually the message text)
      const message = shadow.querySelector('p');

      if (message) {
        message.style.fontSize = '14px';  // Your desired font size
        message.style.color = '#333';     // Change font color
        message.style.fontWeight = '500'; // Add other styles as needed

        clearInterval(interval); // Stop checking once we succeed
      }
    }
  }, 200); // Check every 200ms until it's available
});
